import { useFormik } from "formik";
import { useState, useEffect, useRef } from "react";
import { useJobAlertMutation } from "../api/jobAlertApiSlice";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import * as Yup from 'yup'
import { LgbtToast } from "../../../components/LgbtToast/LgbtToast";
import { useSelector } from "react-redux";


function useJobAlertForm() {
    const { executeRecaptcha } = useGoogleReCaptcha();
    const [AlertResponseMessage, setAlertResponseMessage] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitAlert, { isFetching, isLoading, isError, Error }] = useJobAlertMutation();
    const user = useSelector((state) => state.auth.user || {})
    const formRef = useRef()

    const initialValues = {
        full_name: "",
        job_title_keyword: "",
        email: "",
        location: "",
        work_from_home: false,
        salary_amount: 0,
        minimum_salary: 0,
        maximum_salary: 0,
        contract_type: [],
        sector: [],
        alert_frequency: 1,
        distance: 0,
    }

    const validationSchema = Yup.object({
        'full_name': Yup.string().required('Name is required'),
        'job_title_keyword': Yup.string().required('Job title is required'),
        'email': Yup.string().email('Invalid email format').required('Email is required'),
        'location': Yup.string(),
        'work_from_home': Yup.bool(),
        'contract_type': Yup.array(),
        'salary_amount': Yup.number(),
        'minimum_salary': Yup.number(),
        'maximum_salary': Yup.number(),
        'sector': Yup.array(),
        'alert_frequency': Yup.number(),
        'distance': Yup.number(),
    })

    const jobAlertForm = useFormik({
        initialValues,
        validationSchema,
        onSubmit: async (values, { setStatus, resetForm, setFieldError }) => {
            setIsSubmitting(true);
            try {
                if (!executeRecaptcha) {
                    LgbtToast({ message: 'reCAPTCHA not available. Please refresh the page.', type: 'error' });
                    setAlertResponseMessage('reCAPTCHA error');
                    setIsSubmitting(false);
                    return;
                }

                const recaptchaToken = await executeRecaptcha("alert_form_submission");

                let submissionData = {
                    ...values,
                    recaptcha: recaptchaToken,
                    minimum_salary: values.salary_amount
                };

                if (submissionData.minimum_salary > submissionData.maximum_salary) {
                    LgbtToast({ message: "Minimum salary should be less than maximum salary.", type: 'error' });
                    return;
                }

                const response = await submitAlert(submissionData);

                if (response.error) {
                    LgbtToast({ message: response.error.status, type: 'error' });
                    setAlertResponseMessage('Job Alert not registered');
                } else {
                    LgbtToast({ message: 'Job Alert registered successfully', type: 'success' });
                    setAlertResponseMessage('Job Alert registered successfully');
                    resetForm();
                }

                window.scrollTo({ top: 0, behavior: 'smooth' });
            } catch (error) {
                LgbtToast({ message: 'An error occurred', type: 'error' });
                setAlertResponseMessage('Job Alert not Registered');
            } finally {
                setIsSubmitting(false);
            }
        },
    });

    useEffect(() => {
        if (Object.keys(user).length <= 0 && jobAlertForm) return;

        if (!formRef.current) {
            jobAlertForm.setValues({
                full_name: user.name || user.username || '',
                email: user.email || ''
            });
            formRef.current = true;
        }

    }, [user, jobAlertForm, formRef])

    return { jobAlertForm, isFetching, isLoading, isError, Error, AlertResponseMessage, isSubmitting };
}

export default useJobAlertForm;
